import classnames from 'classnames'
import { memo } from 'react'
import { useSelector } from 'react-redux'
import { RenderProperty } from 'shared/renderProperties'
import { tileEntityAllIdsSelector } from 'client/store/tileEntity'
import { currentPageSelector, totalEntityCountSelector } from 'client/store/paging'
import { stringRenderPropertySelector } from 'client/store/config'
import { productOptionsByProductKeySelector } from 'client/store/productOptionsByProductKey'
import { FullBleedUploadTile } from 'client/components/Gallery/PreviewArea/FullBleedUploadTile/FullBleedUploadTile'
import { CareTile } from 'client/components/Gallery/PreviewArea/CareTile'
import { shouldHideCareTileSelector, shouldHideFbuTileSelector } from 'client/store/refinement/selectors'
import { getIsLoadMoreAvailable } from '~/client/store/config/selectors'
import { DesignSkeleton } from 'client/components/Gallery/PreviewArea/DesignSkeleton'
import { currentPageInfoSelector } from '~/client/store/paging/selectors'
import { useInView } from 'react-intersection-observer'
import { ErrorBoundary } from '@vp/swan'
import { DesignTilesList } from 'client/components/Gallery/PreviewArea/DesignTilesList'

const PreviewListComponent = () => {
  const resultCount = useSelector(totalEntityCountSelector)
  const tileEntityIds = useSelector(tileEntityAllIdsSelector)
  const productOptionsByProductKey = useSelector(productOptionsByProductKeySelector)
  const stringRenderProperty = useSelector(stringRenderPropertySelector)
  const currentPage = useSelector(currentPageSelector)
  const shouldHideFbuTile = useSelector(shouldHideFbuTileSelector)
  const isLoadMoreAvailable = useSelector(getIsLoadMoreAvailable)
  const { pageSize } = useSelector(currentPageInfoSelector)
  const shouldHideCareTile = useSelector(shouldHideCareTileSelector)

  const tilePreviewSize = stringRenderProperty(RenderProperty.TilePreviewSize)

  const isFirstPage = currentPage === 1
  const isFirstPageAndTemplatesExist = isFirstPage && resultCount > 0
  const shouldShowFbuTile = isFirstPageAndTemplatesExist && !shouldHideFbuTile
  const shouldShowCareTile = isFirstPageAndTemplatesExist && !shouldHideCareTile

  // Render Props
  const pricingPresentationType = stringRenderProperty(RenderProperty.PricingPresentationType)
  const { ref } = useInView({ threshold: 1 })

  const careTilePosition = pageSize - 1
  const isCareTileAtEnd = careTilePosition >= tileEntityIds.length
  const shouldShowTileCareAtEnd = shouldShowCareTile && isCareTileAtEnd

  return (
    <ul className={classnames('preview-area', `preview-area-${tilePreviewSize?.toLowerCase()}`, 'stylized-list', 'stylized-list-minimal')} ref={ref}>
      {shouldShowFbuTile && (
        <ErrorBoundary fallback={<>&nbsp;</>} forceShowError={false}>
          <FullBleedUploadTile
            key="fbu-tile"
            pricingPresentationType={pricingPresentationType}
            productOptionsByKey={productOptionsByProductKey}
            userInteractionLocation="tile"
          />
        </ErrorBoundary>
      )}
      <DesignTilesList />
      {shouldShowTileCareAtEnd && <CareTile />}
      {isLoadMoreAvailable && <DesignSkeleton />}
    </ul>
  )
}

export const PreviewList = memo(PreviewListComponent)
